<template>
  <report
    :title="$t('language.yearlyattendancelog')"
    :filter="filter"
    :url="url"
    :landscape="true"
  >
    <template v-slot:filter>
      <v-flex xs12 sm12 md3>
        <ValidationProvider
          :name="$t('language.year')"
          rules="required"
          v-slot="{ errors }"
        >
          <v-autocomplete
            dense
            v-model="filter.year"
            :items="YearList"
            item-text="name"
            item-value="id"
            :label="$t('language.year')"
            :error-messages="errors[0]"
            :clearable="true"
          ></v-autocomplete>
        </ValidationProvider>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <ValidationProvider
          :name="$t('language.person')"
          rules="required"
          v-slot="{ errors }"
        >
          <v-autocomplete
            dense
            v-model="filter.personid"
            :items="PersonList"
            item-text="name"
            item-value="id"
            :label="$t('language.person')"
            :error-messages="errors[0]"
            :clearable="true"
          ></v-autocomplete>
        </ValidationProvider>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.branchid"
          :items="BranchList"
          item-text="name"
          item-value="id"
          :label="$t('language.branch')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.departmentid"
          :items="DepartmentList"
          item-text="name"
          item-value="id"
          :label="$t('language.department')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.designationid"
          :items="DesignationList"
          item-text="name"
          item-value="id"
          :label="$t('language.designation')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.modeid"
          :items="ModeList"
          item-text="name"
          item-value="id"
          :label="$t('language.mode')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
    </template>
    <template v-slot:printheader>
      <table class="printheader">
        <tbody>
          <tr>
            <td>{{ $t("language.year") }}:{{ selectedyear }}}</td>
            <td></td>
            <td>{{ $t("language.person") }}:{{ selectedperson }}</td>
            <td></td>
            <td>{{ $t("language.branch") }}:{{ selectedbranch }}</td>
            <td></td>
            <td>{{ $t("language.department") }}:{{ selecteddepartment }}</td>
            <td></td>
            <td>{{ $t("language.designation") }}:{{ selecteddesignation }}</td>
            <td></td>
            <td>{{ $t("language.mode") }}:{{ selectedmode }}</td>
          </tr>
        </tbody>
      </table>
    </template>
    <template v-slot:table="{ data }">
      <div class="row">
        <div class="col-sm-6">
          <table class="table table-bordered w-100">
            <thead>
              <tr>
                <th :colspan="data.summary.length" class="text-left">
                  <h3>{{ $t("language.summary") }}</h3>
                </th>
              </tr>
              <tr>
                <th v-for="item in data.summary" :key="item.status">
                  {{ getlabel(item.status) }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td v-for="item in data.summary" :key="item.status">
                  {{ item.totaldays }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-sm-6">
          <table
            v-if="data.leavesummary.length > 0"
            class="table table-bordered w-100"
          >
            <thead>
              <tr>
                <th :colspan="6" class="text-left">
                  <h3>
                    {{ $t("language.leave") + " " + $t("language.summary") }}
                  </h3>
                </th>
              </tr>
              <tr>
                <th>{{ $t("language.leave") }}</th>
                <th>{{ $t("language.assigned") }}</th>
                <th>{{ $t("language.transferred") }}</th>
                <th>{{ $t("language.total") }}</th>
                <th>{{ $t("language.taken") }}</th>
                <th>{{ $t("language.balance") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in data.leavesummary" :key="index">
                <td>{{ item.leave }}</td>
                <td>{{ item.assigned }}</td>
                <td>{{ item.transferred }}</td>
                <td>{{ item.total }}</td>
                <td>{{ item.taken }}</td>
                <td>{{ item.balance }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <br class="v-hide" />
      <table v-if="data.officialvisitsummary.length > 0" class="table table-bordered w-100">
        <thead>
          <tr>
            <th :colspan="4" class="text-left">
              <h3>{{ $t("language.officialvisit") + " " + $t("language.summary") }}</h3>
            </th>
          </tr>
          <tr>
            <th>{{ $t("language.person") }}</th>
            <th>{{ $t("language.designation") }}</th>
            <th>{{ $t("language.officialvisit") }}</th>
            <th>{{ $t("language.taken") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data.officialvisitsummary" :key="index">
            <td>{{ item.person }}</td>
            <td>{{ item.designation }}</td>
            <td>{{ item.officialvisit }}</td>
            <td>{{ item.taken }}</td>
          </tr>
        </tbody>
      </table>
      <br class="v-hide" />
      <table class="table table-bordered w-100">
        <thead>
          <tr>
            <th
              class="text-left"
              :colspan="
                ($store.getters.settings.datetype == 'BS' ? 32 : 31) + 2
              "
            >
              <h3>{{ $t("language.detail") }}</h3>
            </th>
          </tr>
          <tr>
            <th>{{ $t("language.month") }}</th>
            <th></th>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>4</th>
            <th>5</th>
            <th>6</th>
            <th>7</th>
            <th>8</th>
            <th>9</th>
            <th>10</th>
            <th>11</th>
            <th>12</th>
            <th>13</th>
            <th>14</th>
            <th>15</th>
            <th>16</th>
            <th>17</th>
            <th>18</th>
            <th>19</th>
            <th>20</th>
            <th>21</th>
            <th>22</th>
            <th>23</th>
            <th>24</th>
            <th>25</th>
            <th>26</th>
            <th>27</th>
            <th>28</th>
            <th>29</th>
            <th>30</th>
            <th>31</th>
            <th v-if="$store.getters.settings.datetype == 'BS'">32</th>
          </tr>
        </thead>
        <tbody v-for="(item, index) in data.detail" :key="index">
          <tr>
            <td :rowspan="rowspan">{{ getlabel(item.month) }}</td>
            <td>{{ $t("language.in") }}</td>
            <td>{{ item.day1.intime }}</td>
            <td>{{ item.day2.intime }}</td>
            <td>{{ item.day3.intime }}</td>
            <td>{{ item.day4.intime }}</td>
            <td>{{ item.day5.intime }}</td>
            <td>{{ item.day6.intime }}</td>
            <td>{{ item.day7.intime }}</td>
            <td>{{ item.day8.intime }}</td>
            <td>{{ item.day9.intime }}</td>
            <td>{{ item.day10.intime }}</td>
            <td>{{ item.day11.intime }}</td>
            <td>{{ item.day12.intime }}</td>
            <td>{{ item.day13.intime }}</td>
            <td>{{ item.day14.intime }}</td>
            <td>{{ item.day15.intime }}</td>
            <td>{{ item.day16.intime }}</td>
            <td>{{ item.day17.intime }}</td>
            <td>{{ item.day18.intime }}</td>
            <td>{{ item.day19.intime }}</td>
            <td>{{ item.day20.intime }}</td>
            <td>{{ item.day21.intime }}</td>
            <td>{{ item.day22.intime }}</td>
            <td>{{ item.day23.intime }}</td>
            <td>{{ item.day24.intime }}</td>
            <td>{{ item.day25.intime }}</td>
            <td>{{ item.day26.intime }}</td>
            <td>{{ item.day27.intime }}</td>
            <td>{{ item.day28.intime }}</td>
            <td>{{ item.day29.intime }}</td>
            <td>{{ item.day30.intime }}</td>
            <td>{{ item.day31.intime }}</td>
            <td v-if="$store.getters.settings.datetype == 'BS'">
              {{ item.day32.intime }}
            </td>
          </tr>
          <tr>
            <td>{{ $t("language.out") }}</td>
            <td>{{ item.day1.outtime }}</td>
            <td>{{ item.day2.outtime }}</td>
            <td>{{ item.day3.outtime }}</td>
            <td>{{ item.day4.outtime }}</td>
            <td>{{ item.day5.outtime }}</td>
            <td>{{ item.day6.outtime }}</td>
            <td>{{ item.day7.outtime }}</td>
            <td>{{ item.day8.outtime }}</td>
            <td>{{ item.day9.outtime }}</td>
            <td>{{ item.day10.outtime }}</td>
            <td>{{ item.day11.outtime }}</td>
            <td>{{ item.day12.outtime }}</td>
            <td>{{ item.day13.outtime }}</td>
            <td>{{ item.day14.outtime }}</td>
            <td>{{ item.day15.outtime }}</td>
            <td>{{ item.day16.outtime }}</td>
            <td>{{ item.day17.outtime }}</td>
            <td>{{ item.day18.outtime }}</td>
            <td>{{ item.day19.outtime }}</td>
            <td>{{ item.day20.outtime }}</td>
            <td>{{ item.day21.outtime }}</td>
            <td>{{ item.day22.outtime }}</td>
            <td>{{ item.day23.outtime }}</td>
            <td>{{ item.day24.outtime }}</td>
            <td>{{ item.day25.outtime }}</td>
            <td>{{ item.day26.outtime }}</td>
            <td>{{ item.day27.outtime }}</td>
            <td>{{ item.day28.outtime }}</td>
            <td>{{ item.day29.outtime }}</td>
            <td>{{ item.day30.outtime }}</td>
            <td>{{ item.day31.outtime }}</td>
            <td v-if="$store.getters.settings.datetype == 'BS'">
              {{ item.day32.outtime }}
            </td>
          </tr>
          <tr>
            <td>{{ $t("language.wh") }}</td>
            <td>{{ item.day1.workedhour }}</td>
            <td>{{ item.day2.workedhour }}</td>
            <td>{{ item.day3.workedhour }}</td>
            <td>{{ item.day4.workedhour }}</td>
            <td>{{ item.day5.workedhour }}</td>
            <td>{{ item.day6.workedhour }}</td>
            <td>{{ item.day7.workedhour }}</td>
            <td>{{ item.day8.workedhour }}</td>
            <td>{{ item.day9.workedhour }}</td>
            <td>{{ item.day10.workedhour }}</td>
            <td>{{ item.day11.workedhour }}</td>
            <td>{{ item.day12.workedhour }}</td>
            <td>{{ item.day13.workedhour }}</td>
            <td>{{ item.day14.workedhour }}</td>
            <td>{{ item.day15.workedhour }}</td>
            <td>{{ item.day16.workedhour }}</td>
            <td>{{ item.day17.workedhour }}</td>
            <td>{{ item.day18.workedhour }}</td>
            <td>{{ item.day19.workedhour }}</td>
            <td>{{ item.day20.workedhour }}</td>
            <td>{{ item.day21.workedhour }}</td>
            <td>{{ item.day22.workedhour }}</td>
            <td>{{ item.day23.workedhour }}</td>
            <td>{{ item.day24.workedhour }}</td>
            <td>{{ item.day25.workedhour }}</td>
            <td>{{ item.day26.workedhour }}</td>
            <td>{{ item.day27.workedhour }}</td>
            <td>{{ item.day28.workedhour }}</td>
            <td>{{ item.day29.workedhour }}</td>
            <td>{{ item.day30.workedhour }}</td>
            <td>{{ item.day31.workedhour }}</td>
            <td v-if="$store.getters.settings.datetype == 'BS'">
              {{ item.day32.workedhour }}
            </td>
          </tr>
          <tr v-if="$store.getters.settings.enablebreakinbreakout">
            <td>{{ $t("language.breakout") }}</td>
            <td>{{ item.day1.breakouttime }}</td>
            <td>{{ item.day2.breakouttime }}</td>
            <td>{{ item.day3.breakouttime }}</td>
            <td>{{ item.day4.breakouttime }}</td>
            <td>{{ item.day5.breakouttime }}</td>
            <td>{{ item.day6.breakouttime }}</td>
            <td>{{ item.day7.breakouttime }}</td>
            <td>{{ item.day8.breakouttime }}</td>
            <td>{{ item.day9.breakouttime }}</td>
            <td>{{ item.day10.breakouttime }}</td>
            <td>{{ item.day11.breakouttime }}</td>
            <td>{{ item.day12.breakouttime }}</td>
            <td>{{ item.day13.breakouttime }}</td>
            <td>{{ item.day14.breakouttime }}</td>
            <td>{{ item.day15.breakouttime }}</td>
            <td>{{ item.day16.breakouttime }}</td>
            <td>{{ item.day17.breakouttime }}</td>
            <td>{{ item.day18.breakouttime }}</td>
            <td>{{ item.day19.breakouttime }}</td>
            <td>{{ item.day20.breakouttime }}</td>
            <td>{{ item.day21.breakouttime }}</td>
            <td>{{ item.day22.breakouttime }}</td>
            <td>{{ item.day23.breakouttime }}</td>
            <td>{{ item.day24.breakouttime }}</td>
            <td>{{ item.day25.breakouttime }}</td>
            <td>{{ item.day26.breakouttime }}</td>
            <td>{{ item.day27.breakouttime }}</td>
            <td>{{ item.day28.breakouttime }}</td>
            <td>{{ item.day29.breakouttime }}</td>
            <td>{{ item.day30.breakouttime }}</td>
            <td>{{ item.day31.breakouttime }}</td>
            <td v-if="$store.getters.settings.datetype == 'BS'">
              {{ item.day32.breakouttime }}
            </td>
          </tr>
          <tr v-if="$store.getters.settings.enablebreakinbreakout">
            <td>{{ $t("language.breakin") }}</td>
            <td>{{ item.day1.breakintime }}</td>
            <td>{{ item.day2.breakintime }}</td>
            <td>{{ item.day3.breakintime }}</td>
            <td>{{ item.day4.breakintime }}</td>
            <td>{{ item.day5.breakintime }}</td>
            <td>{{ item.day6.breakintime }}</td>
            <td>{{ item.day7.breakintime }}</td>
            <td>{{ item.day8.breakintime }}</td>
            <td>{{ item.day9.breakintime }}</td>
            <td>{{ item.day10.breakintime }}</td>
            <td>{{ item.day11.breakintime }}</td>
            <td>{{ item.day12.breakintime }}</td>
            <td>{{ item.day13.breakintime }}</td>
            <td>{{ item.day14.breakintime }}</td>
            <td>{{ item.day15.breakintime }}</td>
            <td>{{ item.day16.breakintime }}</td>
            <td>{{ item.day17.breakintime }}</td>
            <td>{{ item.day18.breakintime }}</td>
            <td>{{ item.day19.breakintime }}</td>
            <td>{{ item.day20.breakintime }}</td>
            <td>{{ item.day21.breakintime }}</td>
            <td>{{ item.day22.breakintime }}</td>
            <td>{{ item.day23.breakintime }}</td>
            <td>{{ item.day24.breakintime }}</td>
            <td>{{ item.day25.breakintime }}</td>
            <td>{{ item.day26.breakintime }}</td>
            <td>{{ item.day27.breakintime }}</td>
            <td>{{ item.day28.breakintime }}</td>
            <td>{{ item.day29.breakintime }}</td>
            <td>{{ item.day30.breakintime }}</td>
            <td>{{ item.day31.breakintime }}</td>
            <td v-if="$store.getters.settings.datetype == 'BS'">
              {{ item.day32.breakintime }}
            </td>
          </tr>
          <tr v-if="$store.getters.settings.enablebreakinbreakout">
            <td>{{ $t("language.breaktaken") }}</td>
            <td>{{ item.day1.breaktaken }}</td>
            <td>{{ item.day2.breaktaken }}</td>
            <td>{{ item.day3.breaktaken }}</td>
            <td>{{ item.day4.breaktaken }}</td>
            <td>{{ item.day5.breaktaken }}</td>
            <td>{{ item.day6.breaktaken }}</td>
            <td>{{ item.day7.breaktaken }}</td>
            <td>{{ item.day8.breaktaken }}</td>
            <td>{{ item.day9.breaktaken }}</td>
            <td>{{ item.day10.breaktaken }}</td>
            <td>{{ item.day11.breaktaken }}</td>
            <td>{{ item.day12.breaktaken }}</td>
            <td>{{ item.day13.breaktaken }}</td>
            <td>{{ item.day14.breaktaken }}</td>
            <td>{{ item.day15.breaktaken }}</td>
            <td>{{ item.day16.breaktaken }}</td>
            <td>{{ item.day17.breaktaken }}</td>
            <td>{{ item.day18.breaktaken }}</td>
            <td>{{ item.day19.breaktaken }}</td>
            <td>{{ item.day20.breaktaken }}</td>
            <td>{{ item.day21.breaktaken }}</td>
            <td>{{ item.day22.breaktaken }}</td>
            <td>{{ item.day23.breaktaken }}</td>
            <td>{{ item.day24.breaktaken }}</td>
            <td>{{ item.day25.breaktaken }}</td>
            <td>{{ item.day26.breaktaken }}</td>
            <td>{{ item.day27.breaktaken }}</td>
            <td>{{ item.day28.breaktaken }}</td>
            <td>{{ item.day29.breaktaken }}</td>
            <td>{{ item.day30.breaktaken }}</td>
            <td>{{ item.day31.breaktaken }}</td>
            <td v-if="$store.getters.settings.datetype == 'BS'">
              {{ item.day32.breaktaken }}
            </td>
          </tr>
          <tr v-if="$store.getters.settings.enableot">
            <td>{{ $t("language.ot") }}</td>
            <td>{{ item.day1.othour }}</td>
            <td>{{ item.day2.othour }}</td>
            <td>{{ item.day3.othour }}</td>
            <td>{{ item.day4.othour }}</td>
            <td>{{ item.day5.othour }}</td>
            <td>{{ item.day6.othour }}</td>
            <td>{{ item.day7.othour }}</td>
            <td>{{ item.day8.othour }}</td>
            <td>{{ item.day9.othour }}</td>
            <td>{{ item.day10.othour }}</td>
            <td>{{ item.day11.othour }}</td>
            <td>{{ item.day12.othour }}</td>
            <td>{{ item.day13.othour }}</td>
            <td>{{ item.day14.othour }}</td>
            <td>{{ item.day15.othour }}</td>
            <td>{{ item.day16.othour }}</td>
            <td>{{ item.day17.othour }}</td>
            <td>{{ item.day18.othour }}</td>
            <td>{{ item.day19.othour }}</td>
            <td>{{ item.day20.othour }}</td>
            <td>{{ item.day21.othour }}</td>
            <td>{{ item.day22.othour }}</td>
            <td>{{ item.day23.othour }}</td>
            <td>{{ item.day24.othour }}</td>
            <td>{{ item.day25.othour }}</td>
            <td>{{ item.day26.othour }}</td>
            <td>{{ item.day27.othour }}</td>
            <td>{{ item.day28.othour }}</td>
            <td>{{ item.day29.othour }}</td>
            <td>{{ item.day30.othour }}</td>
            <td>{{ item.day31.othour }}</td>
            <td v-if="$store.getters.settings.datetype == 'BS'">
              {{ item.day32.othour }}
            </td>
          </tr>
        </tbody>
        <tfoot v-if="data.detail.length == 0">
          <tr>
            <th
              :colspan="
                ($store.getters.settings.datetype == 'BS' ? 32 : 31) + 2
              "
            >
              {{ $t("language.nodatafound") }}
            </th>
          </tr>
        </tfoot>
        <tfoot v-if="data.detail.length > 0">
          <tr>
            <th align="left"
              :colspan="
                ($store.getters.settings.datetype == 'BS' ? 32 : 31) + 2
              "
            >
              {{ data.abbrText }}
            </th>
          </tr>
        </tfoot>
      </table>
    </template>
  </report>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Report from "../Report";
import commonservice from "../../../../shared/common.service";
export default {
  components: {
    Report,
  },
  data() {
    return {
      filter: {
        year: commonservice.getCurrentYear(),
        personid: null,
        branchid: null,
        departmentid: null,
        designationid: null,
        modeid: null,
      },
      YearList: [],
      PersonList: [],
      BranchList: [],
      DepartmentList: [],
      DesignationList: [],
      ModeList: [],
      url: "client/report/yearly/attendancelogs",
    };
  },
  computed: {
    rowspan() {
      let rowspan = 3;
      if (this.$store.getters.settings.enablebreakinbreakout) rowspan += 3;
      if (this.$store.getters.settings.enableot) rowspan += 1;
      return rowspan;
    },
    selectedyear() {
      if (this.filter.year == null) return this.$t("language.all");
      return this.YearList.filter((c) => {
        return c.id == this.filter.year;
      })[0].name;
    },
    selectedperson() {
      if (this.filter.personid == null) return this.$t("language.all");
      return this.PersonList.filter((c) => {
        return c.id == this.filter.personid;
      })[0].name;
    },
    selectedbranch() {
      if (this.filter.branchid == null) return this.$t("language.all");
      return this.BranchList.filter((c) => {
        return c.id == this.filter.branchid;
      })[0].name;
    },
    selecteddepartment() {
      if (this.filter.departmentid == null) return this.$t("language.all");
      return this.DepartmentList.filter((c) => {
        return c.id == this.filter.departmentid;
      })[0].name;
    },
    selecteddesignation() {
      if (this.filter.designationid == null) return this.$t("language.all");
      return this.DesignationList.filter((c) => {
        return c.id == this.filter.designationid;
      })[0].name;
    },
    selectedmode() {
      if (this.filter.modeid == null) return this.$t("language.all");
      return this.ModeList.filter((c) => {
        return c.id == this.filter.modeid;
      })[0].name;
    },
  },
  beforeRouteEnter(to, from, next) {
    axios.get("client/report/yearly/init/list").then((response) => {
      next((p) => {
        p.DepartmentList = response.data.departments;
        p.BranchList = response.data.branches;
        p.DesignationList = response.data.designations;
        p.ModeList = response.data.modes;
        p.YearList = response.data.years;
        p.PersonList = response.data.persons;
      });
    });
  },
  methods: {
    getlabel(textkey) {
      return this.$t("language." + textkey.toLowerCase());
    },
  },
};
</script>
